import React from "react";
import { TbCapture } from "react-icons/tb";
import { useCameraContext } from "../context/CameraContext";

interface CaptureButtonProps {
  onCapture: () => void;
}

const CaptureButton: React.FC<CaptureButtonProps> = ({ onCapture }) => {
  const { state } = useCameraContext();

  if (state.captureMode !== "manual" && !(state.captureMode === "auto" && state.isOrientationCorrect && !state.showTimer)) {
    return null;
  }

  if (state.isCapturing) {
    return null;
  }

  return (
    <div className="fixed z-50 transform -translate-x-1/2 bottom-10 left-1/2">
      <button
        onClick={onCapture}
        className="flex items-center justify-center w-16 h-16 text-xl text-white transition-all duration-200 rounded-full cursor-pointer bg-primary hover:bg-primary-dark active:scale-95"
      >
        <TbCapture />
      </button>
    </div>
  );
};

export default CaptureButton;
